import { useEffect, useState } from "react";
import { BREAK_POINT_MOBILE_MD_LG } from "@app/styles/layout-vars";
import { useWindowSize } from "./useWindowsSize";

const useIsMobile = (breakpoint: number | undefined = undefined) => {
    const [isMobile, setIsMobile] = useState(false);
    const size = useWindowSize();
    useEffect(() => {
        if (size.width) {
            if (size.width < (breakpoint || BREAK_POINT_MOBILE_MD_LG)) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        }
    }, [size]);

    return isMobile;
};

export default useIsMobile;